<script>
import {fileToBase64} from '../../../../_default/utils/fileToBase64'
import {getPublicLinkS3} from '../../../../../domain/grv/services'
import AclCheckMixins from '../../../../_default/components/mixins/AclCheckMixins'
const assets = require.context('../../../../../assets/img/filetype-icons', true)

const templateArquivo = {id: null, nomeArquivo: null, nomeOriginal: null, descricao: null, tipo: null, arquivo: null}

const TIPO_ARQUIVO_PERICIA = 7

export default {
  name: 'ArquivosGrv',
  mixins: [AclCheckMixins],
  props: {
    arquivos: {
      type: Array
    },
    tiposArquivo: {
      type: Array,
      default: () => []
    },
    tiposArquivoOcultar: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      formdataFotosParaUpload: [],
      TIPO_ARQUIVO_PERICIA
    }
  },
  computed: {
    isPermitidoExcluir () {
      return this.possuiACL('excluir_fotos_grv')
    },
    filteredArquivos () {
      if (!this.tiposArquivoOcultar) return this.arquivos
      return this.arquivos.filter(a => this.tiposArquivoOcultar.every(t => t !== a.tipo))
    }
  },
  methods: {
    adicionarArquivo () {
      this.arquivos.push(JSON.parse(JSON.stringify(templateArquivo)))
    },
    uploadDocumento: async function (e) {
      for (let file of e.target.files) {
        this.adicionarArquivo()
        const data = await fileToBase64(file)

        const lastPosition = this.arquivos.length - 1
        this.arquivos[lastPosition].arquivo = data
        this.$el.querySelectorAll('.img-preview')[lastPosition].src = data
      }
    },
    uploadDocumentoPeloCelular: async function (e) {
      for (let file of e.target.files) {
        this.adicionarArquivo()

        const formData = new FormData()
        formData.append('file', file, file.name)
        this.formdataFotosParaUpload.push(formData)

        const data = await fileToBase64(file)

        const lastPosition = this.arquivos.length - 1
        this.arquivos[lastPosition].arquivo = data
        this.arquivos[lastPosition].fromCelular = true
        // this.$el.querySelectorAll('.img-preview')[lastPosition].src = data
      }
    },
    openMultipleInputFile (inputRef) {
      this.$refs[inputRef].click()
    },
    acessarLinkPublicoImagemCompleta (id) {
      this.$loaderOverlay.open()
      getPublicLinkS3(id)
        .then(response => {
          const link = document.createElement('a')
          link.href = `${process.env.API_URL}${response.data}`
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$loaderOverlay.hide()
        })
        .catch(error => {
          alert('Ocorreu um erro ao acessar a imagem, tente novamente')
          this.$loaderOverlay.hide()
          console.log(error)
        })
    },
    geraPreview (arquivo) {
      let preview = ''
      if (arquivo.imageInfo) {
        const {thumb} = arquivo.imageInfo
        preview = (thumb || arquivo.imageInfo.full)['url']
      } else {
        preview = arquivo.arquivo || arquivo.thumb || ''
      }

      if (preview.toLowerCase().endsWith('.pdf')) {
        preview = assets('./icon-pdf.png')
      }
      return preview
    }
  }
}
</script>

<template>
  <div class="table-responsive">
    <table class="table table-hover table-bordered table-striped b-t b-light">
      <thead>
      <tr>
        <th>ID</th>
        <th v-if="isAdministradorExclusivo">Registrado em</th>
        <th>Tipo arquivo</th>
        <th>Preview</th>
        <th v-if="isPermitidoExcluir">Apagar?</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(arquivo, index) in filteredArquivos">
        <td scope="row" width="10%" style="max-width: 10%" class="v-middle">{{arquivo.id}}</td>
        <td scope="row" width="10%" style="max-width: 10%" class="v-middle" v-if="isAdministradorExclusivo">{{arquivo.storageCreatedAt.date | formatDate('DD/MM/YYYY HH:mm')}}</td>
        <td scope="row" class="v-middle">
          <select v-model="arquivo.tipo" class="form-control">
            <option :value="null">Selecione</option>
            <option v-for="tipo in tiposArquivo" :value="tipo.id">{{tipo.nome}}</option>
          </select>
        </td>
        <td scope="row" style="position: relative; display: flex; justify-content: center; align-items: center;">
          <div class="img-preview-placeholder" v-if="!arquivo.id">
            Esta imagem é apenas um preview. <br> Salve a GRV para obter o link da imagem original
          </div>
          <a @click="acessarLinkPublicoImagemCompleta(arquivo.oldId || arquivo.id)">
            <img :src="geraPreview(arquivo)" :ref="`preview-${arquivo.id}`" alt="foto-veiculo" class="img-preview" v-if="arquivo.tipo !== 3" loading="lazy">
            <span v-else>Ver assinatura</span>
          </a>
        </td>
        <td scope="row" class="v-middle" v-if="isPermitidoExcluir && arquivo.tipo !== TIPO_ARQUIVO_PERICIA">
          <label class="i-switch bg-danger m-b-none">
            <input type="checkbox" v-model="arquivo.apagar" :id="'apagar-arquivo'+index" tabindex="0"
                   aria-checked="false" aria-invalid="false"><i></i>
          </label>
        </td>
      </tr>
      <tr v-if="!arquivos || arquivos.length === 0">
        <td colspan="4">Nenhum arquivo nesta GRV</td>
      </tr>
      </tbody>
    </table>
    <div class="wrapper-sm m-t-n m-b">
      <input type="file" name="files[]" id="fileInptImg" multiple ref="fileInptImg" @change="uploadDocumento" v-show="false" accept="image/*">
      <input type="file" name="files[]" id="fileInptImgCelular" multiple ref="fileInptImgCelular" @change="uploadDocumentoPeloCelular" v-show="false" accept="image/*">

      <!--TODO: talvez deixar somente a lógica pelo celular mesmmo; temporariamente ambos utilizarão a lógica de envio pelo celular, por emergência-->
      <button @click="openMultipleInputFile('fileInptImgCelular')" type="button" class="btn btn-info btn-md m-l-xs btn-colsultaGrv">
        Adicionar arquivos
      </button>
      <button @click="openMultipleInputFile('fileInptImgCelular')" type="button" class="btn btn-info btn-md m-l-xs btn-colsultaGrv">
        <i class="fa fa-mobile"></i> Adicionar imagem pelo celular
      </button>
      <br>
      <small>* Você pode selecionar mais de uma foto ao mesmo tempo para enviar</small>
    </div>
  </div>
</template>

<style scoped>
.form-grv label {
  cursor: pointer;
}

.btn-colsultaGrv {
  padding-top: 7px;
  padding-bottom: 7px;
}
.img-preview {
  max-height: 183px;
  max-width: 100px;
}
.img-preview-placeholder {
  position: absolute;
  opacity: 0;
  height: 100%;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.img-preview-placeholder:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, .6)
}
</style>



// WEBPACK FOOTER //
// ArquivosGrv.vue?4801e4f7